import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import {
    LineClamp,
    Tooltip,
    TooltipBody,
    TooltipSubtitle,
} from 'react-wot-bootstrap'

import { LINE_CLAMP_LINES } from './constants.js'

export const DialogRemoveMembersPlayersTooltip = ({ children }) => (
    <Tooltip id={DialogRemoveMembersPlayersTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.dialog_remove_members_players_header"
                    defaultMessage="Исключить из клана игроков:"
                />
            </TooltipSubtitle>
            <LineClamp lines={LINE_CLAMP_LINES}>{children}</LineClamp>
        </TooltipBody>
    </Tooltip>
)
DialogRemoveMembersPlayersTooltip.id = 'dialog-remove-members-players-body'
DialogRemoveMembersPlayersTooltip.propTypes = {
    children: PropTypes.node.isRequired,
}



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Dialogs/tooltips.js